<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 256.462 256.462"
       :aria-labelledby="iconName"
       role="presentation">
    <title :id="iconName" lang="en">{{iconName}}</title>
    <g :fill="color">
      <path d="M67.509,103.278c0,16.475,0.483,31.171,1.939,45.539h-0.322
		c-5.006-12.274-11.307-25.831-17.769-37.305L28.748,71.623H0v108.854h22.614v-32.782c0-17.769-0.328-33.116-1.134-47.645h0.644
		c5.167,12.751,12.435,26.815,18.897,38.427l23.253,42.001h25.843V71.623H67.509V103.278z"/>
	<path d="M103.352,186.778h16.313l34.56-117.094h-16.313L103.352,186.778z"/>
	<path d="M222.54,71.629h-32.293l-33.116,108.854h25.359l7.751-27.949h31.165l8.401,27.949h26.654
		C256.462,180.483,222.54,71.629,222.54,71.629z M193.786,134.12l6.468-23.092c1.778-6.301,3.389-14.541,5.006-21.003h0.322
		c1.617,6.462,3.556,14.541,5.49,21.003l6.784,23.092H193.786z"/>
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      iconName: {
        type: String,
        default: ''
      },
      width: {
        type: [Number, String],
        default: 20
      },
      height: {
        type: [Number, String],
        default: 20
      },
      color: {
        type: String,
        default: 'currentColor'
      }
    }
  }
</script>